import { render, staticRenderFns } from "./TakeNowSliderComponent.vue?vue&type=template&id=5c24ccb9&scoped=true&"
import script from "./TakeNowSliderComponent.vue?vue&type=script&lang=js&"
export * from "./TakeNowSliderComponent.vue?vue&type=script&lang=js&"
import style0 from "./TakeNowSliderComponent.vue?vue&type=style&index=0&id=5c24ccb9&lang=scss&scoped=true&"
import style1 from "./TakeNowSliderComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c24ccb9",
  null
  
)

export default component.exports